import { render } from "./aboutCollegeView.vue?vue&type=template&id=7bcc7b35"
import script from "./aboutCollegeView.vue?vue&type=script&lang=js"
export * from "./aboutCollegeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__